type DestinationModelItem = {
  countryId: string
  clusterId?: string
  name: string
}

export const getDestinationAncestries = (destination?: {
  id: string
  name?: string
  cluster?: DestinationModelItem
  country?: DestinationModelItem
}) => ({
  clusterId: destination?.cluster?.clusterId,
  clusterName: destination?.cluster?.name,
  countryId: destination?.country?.countryId,
  countryName: destination?.country?.name,
  destinationId: destination?.id,
  destinationName: destination?.name,
})

export const getHouseAncestries = (houseDetails: {
  destination: {
    name?: string
    cluster?: DestinationModelItem
    country?: DestinationModelItem
  }
  destinationId: string
}) =>
  getDestinationAncestries({
    id: houseDetails.destinationId,
    ...houseDetails.destination,
  })
